// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-desktop":"(min-width: 992px)","container":"BrowsePageList-module--container--8bb446","breadcrumbs":"BrowsePageList-module--breadcrumbs--43c6c1"};